import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.scss';
import './assets/fonts/lineto-brown-pro-regular.woff';
import './assets/fonts/lineto-brown-pro-bold.woff';

ReactDOM.render(
   <React.StrictMode>
      <App />
   </React.StrictMode>,
   document.getElementById('root')
);
